<template>
  <div>
    <div>
      <!--блок с фото-->
      <div class="uk-position-relative uk-text-center"
           @mousemove="photoAfterVisible = false; beforeVisible = true"
           @mouseleave="photoAfterVisible = true; beforeVisible = false">
        <div v-if="afterVisible && photoAfterVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 1">
          {{ setDescription('main_photo_after') }}
          <img v-if="main_photo_after !== null" :src="main_photo_after" alt="" class="main-photo" loading="lazy">
          <img v-else-if="main_photo_after === null && main_photo_before !== null" :src="main_photo_before" alt="" class="main-photo" loading="lazy">
          <img v-else src="/img/images.png" class="main-photo" alt="">
        </div>

          <div v-else-if="beforeVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 2">
            {{ setDescription('main_photo_before') }}
            <img v-if="main_photo_before !== null" class="main-photo" :src="main_photo_before" alt="">
            <img v-else src="/img/images.png" class="main-photo" alt="">
          </div>

        <div v-else-if="withFacesVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          {{ setDescription('main_photo_before_with_faces') }}
          <img v-if="main_photo_before_with_faces !== null" class="main-photo" :src="main_photo_before_with_faces" alt="" loading="lazy">
          <img v-else class="main-photo" src="/img/images.png" alt="" loading="lazy">
        </div>
        <div v-if=" false && withFacesVisible && (appVersion.indexOf('1.11.12') > -1 || appVersion.indexOf('1.11.11 (168)') > -1)" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          <div
              :style="order_photo_before_url_style">
          </div>
          {{ setDescription('main_photo_before_with_faces') }}
          <img v-if="main_photo_before !== null" class="main-photo" :src="main_photo_before" alt="">
          <img v-else src="/img/images.png" class="main-photo" alt="">
        </div>
        <div v-else-if="zoneVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 5">
          {{ setDescription('zone_photo', zone_photo) }}
          <img v-if="zone_photo !== null" class="main-photo" :src="zone_photo" alt="" loading="lazy">
          <img v-else class="main-photo" src="/img/images.png" alt="">
        </div>
        <!--блокирующий слой загрузки фото через правую кнопку мыши-->
        <div class="uk-position-cover"></div>
      </div>
      <!--блок подписи фото-->
      <div style="padding: 5px;background-color: #f0f0f0;border-top: 5px solid #f8f8f8;">
        <div class="uk-grid uk-grid-small uk-flex-middle uk-animation-slide-small-medium 1" data-uk-grid>
          <!--кнопка СКАЧАТЬ-->
          <div class="uk-width-1-3 tm-main-photo-block-under-buttons">
            <div>
              <div class="uk-grid uk-grid-small uk-child-width-expand uk-flex-middle" data-uk-grid>
                <div>
                  <md-field style="background-color: #fff;padding-left: 5px;">
                    <label>{{ local_page_keys.label_download_photo }}:</label>
                    <md-select
                        style="z-index: 150;"
                        v-model="selected1"
                        name="select1"
                        ref="select1"
                        id="select1"
                        :disabled="disabledDowloadFile"
                        @md-selected="textarea1 = null">
                      <md-option
                          v-for="option of select1"
                          :key="option.index"
                          :value="option.value">
                        {{ option.text }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="uk-width-auto">
                  <button
                      type="button"
                      class="tm-button-grey uk-button uk-button-small-padding uk-width-1-1 uk-box-shadow-medium uk-box-shadow-hover-large"
                      style="min-height: 38px;font-weight: 400;min-width: 40px;"
                      @click="downloadSelected"
                      :disabled="disabledDowloadFile">
                    <template v-if="!disabledDowloadFile">
                      <md-icon class="uk-light">download</md-icon>
<!--                      {{ local_page_keys.button_download }}-->
                    </template>
                    <template v-else>
                      <v-progress-circular :width="2" indeterminate style="color: white"/>
                    </template>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--тип отображаемого фото-->
          <div class="uk-width-1-3">
            <div class="tm-center-photo-hover-description">
              <span v-if="isLoading" class="uk-icon uk-spinner uk-margin-small-left uk-light" data-uk-spinner="ratio: 0.7"></span>
              <div class="uk-text-truncate" v-else>
                <template v-if="description">
                  {{ description }}
                </template>
                <template v-else>
                  no data
                </template>
              </div>
            </div>
          </div>
          <div class="uk-width-1-3"></div>
        </div>
      </div>
      <!--блок кнопок-->
      <div style="padding: 0;margin-top: 7px;" class="uk-background-muted-">
        <div class="uk-grid uk-grid-small uk-child-width-1-2 tm-main-photo-block-under-buttons" data-uk-gri>
          <!--кнопка ЗАКАЗ ГОТОВ-->
          <div>
            <form @submit.prevent="() => submitFile(false)">
              <div class="uk-grid uk-grid-small uk-child-width-expand uk-flex-middle" data-uk-grid>
                <div>
                  <md-field>
                    <label>{{ local_page_keys.label_downloading_a_file }}</label>
                    <md-file
                        :placeholder="local_page_keys.placeholder_download_a_completed_order"
                        ref="file"
                        :value="file1"
                        :key="file1 ? Date.now() : 'default'"
                        @change="selectedFile"/>
                    <button class="clear-button" @click="clearFileReady" v-if="file1">
                      <md-icon>clear</md-icon>
                    </button>
                  </md-field>
                </div>
                <div class="uk-width-auto">
                  <button
                      type="submit"
                      class="uk-button uk-button-success uk-button-small-padding uk-width-1-1 uk-box-shadow-medium uk-box-shadow-hover-large"
                      style="min-height: 38px;font-weight: 400;"
                      :disabled="isLoading">
                    <md-icon class="uk-light">done</md-icon> {{ local_page_keys.button_order_ready }}
                  </button>
                  <!--                <md-button type="submit" :disabled="isLoading" class="md-success uk-width-1-1">-->
                  <!--                  <md-icon>done</md-icon>-->
                  <!--                  {{ local_page_keys.button_order_ready }}-->
                  <!--                </md-button>-->
                </div>
              </div>
            </form>
          </div>
          <!--кнопка ПРОБЛЕМА-->
          <div>
            <form @submit.prevent="submitProblem">
              <div class="uk-grid uk-grid-small uk-child-width-expand uk-flex-middle" data-uk-grid>
                <div>
                  <md-field>
                    <label>{{ local_page_keys.label_problem_with_the_order }}:</label>
                    <md-select
                        style="z-index: 150;"
                        v-model="selected2"
                        name="select2"
                        ref="select2"
                        id="select2"
                        v-bind:disabled="hasFileReady">
                      <md-option value="">
                        {{ local_page_keys.label_select_an_option }}
                      </md-option>
                      <md-option :value="local_page_keys.kontent_dlya_vzroslyh" :data-uk-tooltip="'title: ' + local_page_keys.kontent_dlya_vzroslyh_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.kontent_dlya_vzroslyh }}
                      </md-option>
                      <md-option :value="local_page_keys.zaprescheno_dlya_detey" :data-uk-tooltip="'title: ' + local_page_keys.zaprescheno_dlya_detey_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.zaprescheno_dlya_detey }}
                      </md-option>
                      <md-option :value="local_page_keys.nelzya_primenit_vybrannyy_shablon_k_foto" :data-uk-tooltip="'title: ' + local_page_keys.nelzya_primenit_vybrannyy_shablon_k_foto_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.nelzya_primenit_vybrannyy_shablon_k_foto }}
                      </md-option>
                      <md-option :value="local_page_keys.nelzya_primenit_vybrannye_uslugi_k_foto" :data-uk-tooltip="'title: ' + local_page_keys.nelzya_primenit_vybrannye_uslugi_k_foto_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.nelzya_primenit_vybrannye_uslugi_k_foto }}
                      </md-option>
                      <md-option :value="local_page_keys.ne_vybran_chelovek_dlya_redaktirovaniya" :data-uk-tooltip="'title: ' + local_page_keys.ne_vybran_chelovek_dlya_redaktirovaniya_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.ne_vybran_chelovek_dlya_redaktirovaniya }}
                      </md-option>
                      <md-option :value="local_page_keys.nizkoe_kachestvo_foto" :data-uk-tooltip="'title: ' + local_page_keys.nizkoe_kachestvo_foto_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.nizkoe_kachestvo_foto }}
                      </md-option>
                      <md-option :value="local_page_keys.fayl_povrezhden" :data-uk-tooltip="'title: ' + local_page_keys.fayl_povrezhden_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.fayl_povrezhden }}
                      </md-option>
                      <md-option :value="local_page_keys.pereslat_drugomu_retusheru" :data-uk-tooltip="'title: ' + local_page_keys.pereslat_drugomu_retusheru_description + '; pos: right;delay: 500;offset: 5'">
                        ⭕️ {{ local_page_keys.pereslat_drugomu_retusheru }}
                      </md-option>
                      <md-option :value="local_page_keys.label_add_a_comment" :data-uk-tooltip="'title: ' + local_page_keys.label_add_a_comment_description + '; pos: right;delay: 500;offset: 5'">
                        {{ local_page_keys.label_add_a_comment }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="uk-width-auto">
                  <button
                      type="submit"
                      class="uk-button uk-button-danger uk-button-small-padding uk-width-1-1 uk-box-shadow-medium uk-box-shadow-hover-large"
                      style="min-height: 38px;font-weight: 400;">
                    <md-icon class="uk-light">close</md-icon> {{ local_page_keys.button_problem }}
                  </button>
                </div>
              </div>
              <!--поле указания причины-->
              <md-field
                  v-if="selected2 === local_page_keys.label_add_a_comment"
                  style="padding-bottom: 0;border-top: 1px solid rgb(210, 210, 210);border-left: 1px solid rgb(210, 210, 210);border-right: 1px solid rgb(210, 210, 210);"
                  class="uk-animation-slide-bottom-small uk-margin-small-top">
                <label>{{ local_page_keys.label_add_a_comment }}</label>
                <md-textarea v-model="textarea1" ref="text"></md-textarea>
              </md-field>
            </form>
          </div>
        </div>
      </div>
    </div>
    <ModalPrevalidateAfterImageDialog
      @close="hideInfoModal()"
      @send="submitFile"
      :preValidateInfoContent="preValidateInfoContent"
      :modalType="modalType"
      :local_page_keys="local_page_keys"
      :disableConfirmButton="disableConfirmButton"
      v-if="showedInfoModal"/>
    <ModalDropOrderForRetoucherDialog
      v-if="showedDropOrderModal"
      @reload="reloadOrder"
      :local_page_keys="local_page_keys"/>
  </div>
</template>

<script>
import ModalPrevalidateAfterImageDialog from "@/pages/Dashboard/Components/Dialogs/ModalPrevalidateAfterImageDialog";
import ModalDropOrderForRetoucherDialog from "@/pages/Dashboard/Components/Dialogs/ModalDropOrderForRetoucherDialog";
import axios from 'axios';

export default {
  name: "RetouchersMainPhotoBlock",
  components:  {ModalPrevalidateAfterImageDialog, ModalDropOrderForRetoucherDialog},
  props: {
    education: {
      type: Number,
    },
    order_photo_after_last_not_education: {
      type: Number,
    },
    cost: {
      type: Number,
      require: true
    },
    order_number: {
      type: String,
      require: true
    },
    main_photo_block: {
      type: Object,
      require: true
    },
    zone_photo: {
      require: true,
    },
    withFacesVisible: {
      type: Boolean,
      require: true
    },
    afterVisible: {
      type: Boolean,
      require: true
    },
    zoneVisible: {
      type: Boolean,
      require: true
    },
    auto_order_check: {
      type: Number,
      default: 1
    },
    resolution:{
      type: Object,
      require: true,
    },
  },
  data: () => ({
    actionBlockSelects: null,
    main_photo_after: null,
    main_photo_before: null,
    main_photo_before_with_faces: null,
    selected1: null,
    selected2: '',
    textarea1: null,
    file1: null,
    file: null,
    selectedVersion: null,
    select1: [],
    select_problem: {},
    photoAfterVisible: true,
    beforeVisible: false,
    main_modal_photo_before: '',
    main_modal_photo_after: '',
    local_page_keys: {},
    local_page_keys_statuses:{},
    local_page_keys_functions: {},
    orderId: '',
    images_types: 'image/jpeg,image/png',
    selectedFileLoading: false,
    description: '',
    functionsClientFile: null,
    intervalCheckDownloadFile: null,
    enableCheckFileDownload: true,
    orderPagePathName:'/new_mvp/order-new-idle-time',
    auto_order_check_func_based: 0,
    preValidateInfoContent: [],
    disableConfirmButton:false,
    modalType:'warning',
    showedInfoModal: false,
    showedDropOrderModal: false,
    loadingDowload:false
  }),
  methods: {
    /**
     * Method to download selected file in main-photo block select or formated to base64 string
     * of url-address to image in info-block to retoucher's computer
     * accept as argument string of url-address
     * */
    async downloadSelected() {
       if (this.selected1 !== null) {
        this.loadingDowload = true;

        this.selectedFileLoading = true;
        let inStorageFile = this.selected1.includes('storage/order_photos')

        if (inStorageFile) {
          let filename = this.selected1.slice((this.selected1.lastIndexOf('/') + 1));
          filename = filename.split('?')[0];
          await this.$store.dispatch('order/downloadFromBackFile', {
            order_number: this.order_number,
            order_id: this.orderId,
            filename,
            download:true
          });
          let dataUrl = await this.$store.getters['order/downloadFromBackFile'];
          await fetch(dataUrl, {
            method: "GET"
          }).then(response => response.blob())
              .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again
              });

        } else {
          let searchParams = new URLSearchParams(this.selected1);
          //let filename = searchParams.has('fn') ? searchParams.get('fn') : this.selected1.slice((this.selected1.lastIndexOf('/') + 1));
          let image = this.select1.find(image => image.value === this.selected1);
          let filename = image ? image.linkfilename : this.selected1;

          let urlObj = new URL(this.selected1);
          if (urlObj.hostname === 'appfls.fixthephoto.com') {
            urlObj.hostname = 'fdl.retoucher.app';
          }

          await this.$store.dispatch('order/downloadFromBackFile', {
            order_number: this.order_number,
            order_id: this.orderId,
            filename: urlObj,
            download:false
          });

          await fetch(urlObj, {
            method: 'GET',
            mode: 'cors',
          })
              .then(response => response.blob())
              .then(blob => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();  //afterwards we remove the element again
                URL.revokeObjectURL(link.href)
              }).catch(e => alert(e))

        }
         this.selected1 = this.select1[0].value;
         this.selectedFileLoading = false;
        this.loadingDowload = false;
      } else {
        alert(this.local_page_keys.alert_photo_not_selected)
      }
    },
    selectedFile(event) {
      this.file = event.target.files[0];
      this.file1 = event.target.files[0]['name'];
      this.selected2 = '';
      this.textarea1 = null;
    },
    async submitProblem() {
      if (!!this.file1) {
        alert(this.local_page_keys.alert_disable_send_problem);
        return;
      }
      if (this.selected2 !== '') {
        let subject = this.selected2;
        let problem = 'problem';
        let formData = new FormData();
        let order_id = this.orderId;
        formData.append('problem', problem);
        formData.append('order_id', order_id);
        formData.append('auto_order_check', new Number(this.auto_order_check).toString());
        if(this.auto_order_check_func_based > 0) formData.append('auto_order_check_func_based', new Number(this.auto_order_check_func_based).toString());
        if (this.selected2 == this.local_page_keys_statuses.pereslat_drugomu_retusheru) {
          formData.append('reason', 8);
        }
        if (this.selected2 === this.local_page_keys.label_add_a_comment && this.textarea1 !== null && this.textarea1.trim() !== '') {
          formData.append('message', this.textarea1);
          formData.append('subject', '');
          this.sendProblem(formData, subject);
        } else if (this.selected2 !== this.local_page_keys.label_add_a_comment) {
          formData.append('subject', subject);
          this.sendProblem(formData, subject);
        } else {
          alert(this.local_page_keys.alert_add_a_comment);
          return;
        }
      } else {
        alert(this.local_page_keys.alert_no_data_entered);
      }
    },
    async submitFile(ignore_pre_validate) {
      if (this.file) {
        if (this.images_types.includes(this.file.type)) {
          let formData = new FormData();
          formData.append('ignore_pre_validate', ignore_pre_validate);
          formData.append('file', this.file);
          formData.append('order_id', this.orderId);
          formData.append('auto_order_check', new Number(this.auto_order_check).toString());
          if (this.auto_order_check_func_based > 0) formData.append('auto_order_check_func_based', new Number(this.auto_order_check_func_based).toString());
          if (this.textarea1 !== null && this.textarea1.trim() !== '') {
            formData.append('problem_comment', this.textarea1);
          }
          let msg = this.local_page_keys.alert_confirm_the_shipment_of_the_finished_order;
          this.hideInfoModal();

          if (!ignore_pre_validate) {
            let msg = this.local_page_keys.alert_confirm_the_shipment_of_the_finished_order;
            if (!confirm(msg)) {
              return;
            }
          }
          try {
            let data;
            this.$emit('is-loading', true);
            await this.$store.dispatch("order/submitFile", formData);
            data = await this.$store.getters['order/submitFile'];
            if (data.success) {
              this.$emit('retry', true);
            } else if (data.info) {
              this.disableConfirmButton = false;
              this.$emit('is-loading', false);
              this.preValidateInfoContent = data.info;
              this.preValidateInfoContent.push(this.local_page_keys.validate_diff_question)
              this.modalType = 'warning';
              this.showInfoModal();
            } else if (data.warning) {
              this.$emit('is-loading', false);
              this.preValidateInfoContent = data.warning;
              this.disableConfirmButton = true;
              this.modalType = 'error';
              this.showInfoModal();
            } else {
              alert(data.error);
              this.$emit('is-loading', false);
              this.$emit('retry', true);
            }
          } catch (e) {
            alert(this.local_page_keys.alert_truble_data_send);
            this.$emit('is-loading', false);
            this.$emit('retry', true);
          }
        } else {
          let msg = this.local_page_keys.allowed_file_types ?? "Sorry, but this format doesn't allowed";
          alert(msg);
        }
      } else {
        alert(this.local_page_keys.alert_file_is_not_loaded_Repeat_the_download);
      }

    },
    async sendProblem(formData, subject) {
      if (confirm(this.local_page_keys.alert_do_you_confirm_sending_the_problem_message)) {
        //logEvent(this.$analyticsInit, "order_cancel", {orderId: this.orderId, cost: this.cost, cause: subject});
        this.$emit('is-loading', true);
        try {
          await this.$store.dispatch("order/submitProblem", formData);
          let data = await this.$store.getters["order/submitProblem"];
          if (data.success === 'Success') {
            this.$emit('retry', true);
          } else {
            this.$emit('retry', true);
            alert(data.error);
          }
        } catch (e) {
          alert(this.local_page_keys.alert_truble_data_send);
          this.$emit('retry', true);
        }

      }
    },
    async getActionBlockSelects() {
      await this.$store.dispatch("order/getActionBlockSelects");
      let actionsInfo = await this.$store.getters['order/getActionBlockSelects'];
      let selects = {};
      selects.select_download = [];
      selects.select_problem = actionsInfo.rejection_options;
      let photos = actionsInfo.photos;
      let versions = Object.keys(photos);

      versions.forEach(version => {
          if(typeof this.order_photo_after_last_not_education == 'number'
              && typeof this.education == 'number'
              && this.education == 1
              && this.order_photo_after_last_not_education > 0
              && version  > this.order_photo_after_last_not_education) {
            selects.select_download.push({
              value: photos[version].link,
              text: `Version ${version}(${photos[version].size})`,
              size: photos[version].size,
              linkfilename: photos[version].linkfilename
            });
          }
          if(!(typeof this.order_photo_after_last_not_education == 'number'
              && typeof this.education == 'number'
              && this.education == 1)){
            selects.select_download.push({
              value: photos[version].link,
              text: `Version ${version}(${photos[version].size})`,
              size: photos[version].size,
              linkfilename: photos[version].linkfilename
            });
          }


      });
      if (selects.select_download.length !== 0) {
        for (let option of selects.select_download) {
          this.select1.unshift(option);
        }
      }
      if (this.main_photo_before !== null) {
        let option = {
          value: this.main_photo_before,
          text: this.local_page_keys.label_original_photo,
          linkfilename: 'order_photo_before_url.jpg'
        }
        this.select1.push(option)
      }
      if (this.select1.length !== 0) {
        this.selected1 = this.select1[0].value;
      }
      this.select_problem = selects.select_problem;
    },
    setDescription(type, file = null) {
      switch (type) {
        case "main_photo_after":
          this.description = this.local_page_keys.description_photo_marking_after;
          break;
        case "main_photo_before":
          this.description = this.local_page_keys.description_photo_marking_before;
          break;
        case "main_photo_before_with_faces":
          this.description = this.local_page_keys.description_photo_marking_face_zone;
          break;
        case "zone_photo":
          let fileName = this.parseFileName(file);
          if(fileName && fileName.length > 0 && fileName.indexOf(" ") > -1){
            let fileNameSplit = fileName.split(" ");
            if(fileNameSplit.length == 2
                && ('main_photo_after').indexOf((fileNameSplit[0]).toLowerCase()) > -1){
              this.description = this.local_page_keys.description_photo_marking_after + ' ' + fileNameSplit[1];
              break;
            }
          }
          this.description = this.parseFileName(file)
          break;
        default:
          this.description = '';
          break;
      }
    },
    parseFileName(url) {
      if (!url)
        return '';

      let image = this.select1.find(image => image.value === url);
      let file = image ? image.linkfilename : url;

      //https://api.fix-dashboard.vagrant/storage/order_photos/1051611180/order_photo_after_1.jpg
      if (file.includes("order_photo_")) {
        const regex = /order_photo_(.*)\.(.*)/i;
        const match = file.match(regex);
        if (match && match[1]) {
          const result = match[1].replace(/_/g, ' ');
          return result;
        }
      }
      //https://nvp2.retoucher.app:10001//storage/elements/tiny/order_eyebrow_piercing_12_tiny.jpg/
      if (file.includes("elements/tiny/")) {
        const regex = /order_(.*)\_tiny.jpg/i;
        const match = file.match(regex);
        if (match && match[1]) {
          const result = match[1].replace(/_/g, ' ');
          return result;
        }
      }
      //https://fix-dashboard.vagrant/api/storage/client_files/82925_1687436164.jpg
      if (file.includes("client_files/") && this.functionsClientFile) {
        const functionName = Object.keys(this.functionsClientFile).find(key => this.functionsClientFile[key] === file);

        if (this.local_page_keys_functions[functionName] !== undefined )
          return this.local_page_keys.client_photo_label + ' "' + this.local_page_keys_functions[functionName ] + '"';
        else
          return this.local_page_keys.client_photo_label;
      }
      //https://dl.dropbox.com/s/5nk7v46ejitrjjd/1687299957380971_redo.jpg
      if (file.includes("_redo")) {
        return this.local_page_keys.description_photo_return;
      }
      //https://retoucher.app:10001/storage/order_photos/528544183/adminComments20230608145202_528544183.jpeg
      if (file.includes("adminComments")) {
        return this.local_page_keys.description_admin_comment;
      }
    },
    async fetchFunctionsClientFile() {
      await this.$store.dispatch('order/orderFunctionsClientFile', {order_id: this.orderId})
      let data = this.$store.getters['order/orderFunctionsClientFile'];
      this.functionsClientFile = typeof data !== 'string' ? data : null;
    },
    clearFileReady() {
      this.file1 = null;
      this.file = null;
      this.$refs.file.value = '';
    },
    checkDownloadFile(data) {
      if (!this.enableCheckFileDownload)
        return;
      try {
        // await this.$store.dispatch("order/checkDownloadFile", this.orderId);
        // let data = this.$store.getters['order/checkDownloadFile'];
        if (data) {
          if(!(typeof this.education == 'number' && this.education == 1)) {
            let dropOrder = data.drop_order
            if (dropOrder === true) {
              this.enableCheckFileDownload = false;
              //this.showDropOrderAlert = true;
              this.showDropOrderAlertModal();
              let audio = new Audio('/audio/my-work.mp3');
              setTimeout(function () {
                audio.play();
              }, 150);
            }
          }
        } else {
          this.errors = 'Failed check';
        }
      } catch (e) {
        alert(e);
      }
    },
    checkOrderPageFuncBasedPath() {
        if (window.location.pathname === this.orderPagePathName) {
          this.auto_order_check_func_based = 1;
        }
    },
    showDropOrderAlertModal() {
      this.showedDropOrderModal = true;
    },
    hideDropOrderAlertModal() {
      this.showedDropOrderModal = false;
    },
    showInfoModal() {
      this.showedInfoModal = true;
    },
    hideInfoModal() {
      this.showedInfoModal = false;
    },
    getHeaderModal() {
      let data = {class: 'uk-text-' + this.modalType , icon: this.modalType}
      if (this.modalType === 'error'){
        data.class = 'uk-text-danger';
      }
      return data;
    },
    reloadOrder() {
      this.$emit('retry', true);
    },
    addBaseUrl(url){
      if (this.isURL(url))
        return url;

      if(url.length > 0 && url[0] != '/') url = '/' + url;
      let host = (process.env.VUE_APP_BASE_URL).replace(/\+$/, '');
      return host + url;
    },
    isURL(str) {
      if(!str)
        return false;

      return str  ? str.startsWith('http://') || str.startsWith('https://') : str;
    }

  },
  computed: {
    disabledDowloadFile() {
      return this.selectedFileLoading;
    },
    isLoading() {
      return this.$store.state.loading.isLoading;
    },
    hasFileReady() {
      return !!this.file1;
    },
    appVersion(){
      let app = 1;
      if('app' in this.main_photo_block && this.main_photo_block.app){
        app =this.main_photo_block.app;
      }
      sessionStorage.setItem('appVersion', '' + app);
      return app;
    },
    order_photo_before_url_style(){
      let style = 'position: absolute;' +
          'background-color: #b62626;' +
          'aspect-ratio: '+this.aspectRatio+';' +
          'bottom: 0;' +
          'top: 50%;' +
          'left: 50%;' +
          'transform: translate(-50%, -50%);' +
          'width: max-content;height: 100%;' +
          'opacity: 0.5;' +
          'background-image: url('+this.addBaseUrl(this.main_photo_block.main_photo_before_with_faces)+');' +
          'background-position: 50%;' +
          'background-size: cover;';
      let dim = this.resolution.order_photo_before_url.height > this.resolution.order_photo_before_url.width ? 'height:100%; width: max-content;': 'width:100%; height: max-content;';


      // let style = 'position: absolute;' +
      //     'background-color: #b62626;' +
      //     'aspect-ratio: '+this.aspectRatio+';' +
      //     'bottom: 0;' +
      //     'top: 50%;' +
      //     'left: 50%;' +
      //     'transform: translate(-50%, -50%);' +
      //     'width: max-content;height: 100%;' +
      //     'opacity: 0.5;' +
      //     'background-image: url('+this.main_photo_before_with_faces+');';
      //
      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
          && this.resolution.order_photo_before_url.height / this.resolution.order_photo_before_url.width > 2){

        return style +
            'background-size: 155%;' +
            'background-position-x: calc(50% - -20%);' +
            'background-position-y: calc(50% - 57%);';
      }
      // if('order_photo_before_url' in this.resolution
      //     && 'width' in this.resolution.order_photo_before_url
      //     && 'height' in this.resolution.order_photo_before_url
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height > 1
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height < 2){
      //
      //   return style +
      //       'background-size: auto;' +
      //       'background-position-x: calc(50% - 0%);' +
      //       'background-position-y: calc(50% - 0%);';
      // }
      // if('order_photo_before_url' in this.resolution
      //     && 'width' in this.resolution.order_photo_before_url
      //     && 'height' in this.resolution.order_photo_before_url
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height >= 2){
      //
      //   return style +
      //       'background-size: 40%;' +
      //       'background-position-x: calc(50% - 0%);' +
      //       'background-position-y: calc(50% - 0%);';
      // }
      // return style + 'background-position: 50%;' +
      //     'background-size: cover;';

      return style + dim;
    },
    aspectRatio(){
      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
      ){
        return ' ' + this.resolution.order_photo_before_url.width + '/' + this.resolution.order_photo_before_url.height;
      }
      return '';
    },
  },
  async created() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('order-photo-block'), await this.$filtergetLocalisationPage('rejection_options'));
    this.local_page_keys_statuses = await this.$filtergetLocalisationPage('rejection_options');
    this.local_page_keys_functions = await this.$filtergetLocalisationPage('ru_retoucher_translations');
    await this.getActionBlockSelects();
    // if(!(typeof this.education == 'number' && this.education == 1)){
    //   this.intervalCheckDownloadFile = setInterval(() => {
    //     this.checkDownloadFile();
    //   }, 10000);
    // }
    this.checkOrderPageFuncBasedPath();
  },
  mounted() {
    //console.log(this.main_photo_block)
    this.orderId = this.main_photo_block.order_id;

    // this.main_photo_before_with_faces = this.isURL( this.main_photo_block.order_photo_before_url_with_faces) ?  this.main_photo_block.order_photo_before_url_with_faces : this.main_photo_block.order_photo_before_url_with_faces ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + this.main_photo_block.order_photo_before_url_with_faces : null;
    // this.main_photo_before = this.isURL(this.main_photo_block.order_photo_before_url) ? this.main_photo_block.order_photo_before_url : this.main_photo_block.order_photo_before_url ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + this.main_photo_block.order_photo_before_url : null;
    // this.main_photo_after = this.main_photo_block.order_photo_after ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + this.main_photo_block.order_photo_after : null;

    this.main_photo_before_with_faces =  this.main_photo_block.order_photo_before_url_with_faces;
    this.main_photo_before = this.main_photo_block.order_photo_before_url
    this.main_photo_after = this.main_photo_block.order_photo_after


    this.fetchFunctionsClientFile();
  },
  beforeDestroy() {
    clearInterval(this.intervalCheckDownloadFile);
  },
  destroyed() {
    this.hideDropOrderAlertModal();
    this.hideInfoModal();
  }
}
</script>
<style>
  @import '../../../../assets/css/uikit/visibility.css';
  .md-menu-content.md-select-menu {
    z-index: 150;
  }
  .tm-main-photo-block-under-buttons .uk-button {
    min-width: 140px;
    text-align: center;
  }
  .tm-main-photo-block-under-buttons .md-field:after,
  .tm-main-photo-block-under-buttons .md-field:before {
    bottom: 0;
  }
  .tm-main-photo-block-under-buttons .md-field {
    padding-bottom: 0;
    margin: 0;
  }
  .tm-main-photo-block-under-buttons .md-field.md-focused label,
  .tm-main-photo-block-under-buttons .md-field.md-field.md-has-value label {
    top: -7px;
  }
  .tm-center-photo-hover-description {
    background: #f8f8f8;
    line-height: 34px;
    padding: 0 10px;
    text-align: center;
    border-radius: 5px;
    font-size: 14px;
  }
</style>